// extracted by mini-css-extract-plugin
export default {"spinner-div":"Spinner_spinner-div__tcAA0","spinner":"Spinner_spinner__HPfEE"};